import React from "react";
import "./EditProfile.css";
import "./Navbar.css";
import { toast } from "react-toastify";
import { updateUser, uploadFile } from "../api";

import { NavLink } from "react-router-dom";

class EditProfile extends React.Component {
  state = {
    _id: "",
    username: "",
    imageUrl: "",
    dateOfBirth: "",
    location: "",
    firstName: "",
    lastName: "",
    mobilePhone: "",
    address: "",
    city: "",
    countryRegion: "",
    postCode: "",
    email: "",
  };

  handleFileChange = (event) => {
    this.setState({
      imageUrl: event.target.files[0],
    });
  };

  handleChange = (event) => {
    let { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleFormSubmit = async (event) => {
    event.preventDefault();
    const {
      _id,
      username,
      imageUrl,
      dateOfBirth,
      location,
      email,
      firstName,
      lastName,
      mobilePhone,
      address,
      city,
      countryRegion,
      postCode,
    } = this.state;

    let image = "";
    if (typeof imageUrl !== "string") {
      const uploadData = new FormData();
      uploadData.append("file", imageUrl);

      const response = await uploadFile(uploadData);
      image = response.data.fileUrl;
    } else {
      image = imageUrl;
    }

    const newUser = {
      _id,
      username,
      dateOfBirth,
      location,
      email,
      firstName,
      lastName,
      mobilePhone,
      address,
      city,
      countryRegion,
      postCode,
      imageUrl: image,
    };

    const response = await updateUser(newUser);
    toast.dark(`Profile updated successfully!`);
    this.props.setCurrentUser(response.data);
    this.props.history.push(`/profile`);
  };

  async componentDidMount() {
    this.setState({
      _id: this.props.user._id,
      username: this.props.user.username,
      imageUrl: this.props.user.imageUrl,
      dateOfBirth: this.props.user.dateOfBirth,
      location: this.props.user.location,
      firstName: this.props.user.firstName,
      lastName: this.props.user.lastName,
      mobilePhone: this.props.user.mobilePhone,
      address: this.props.user.address,
      city: this.props.user.city,
      countryRegion: this.props.user.countryRegion,
      postCode: this.props.user.postCode,
      email: this.props.user.email,
    });
  }

  render() {
    const {
      username,
      imageUrl,
      dateOfBirth,
      location,
      email,
      firstName,
      lastName,
      mobilePhone,
      address,
      city,
      countryRegion,
      postCode,
    } = this.state;

    return (
      <main className="box">
        <div className="backMenuBox">
          <NavLink to="/profile">
            <img src="/images/back.png" />
          </NavLink>

          <h1>Your Details</h1>
        </div>

        <form
          className="formBox"
          onSubmit={this.handleFormSubmit}
          encType="multipart/form-data"
        >
          <article className="topBox">
            <h1>Public details</h1>
            <section className="topDetailsBox">
              <div className="img">
                {this.props.user && (
                  <img src={this.props.user.imageUrl} alt="User Image" />
                )}
                <input
                  autocomplete="off"
                  className="imgFileBox"
                  type="file"
                  name="imageUrl"
                  onChange={this.handleFileChange}
                />
              </div>

              <input
                autocomplete="off"
                className="nameBox"
                type="text"
                name="username"
                value={username}
                onChange={this.handleChange}
              />
            </section>

            <section className="inputBox">
              <label>Date of Birth</label>
              <div>
                <input
                  autocomplete="off"
                  type="number"
                  name="dateofbirth"
                  value={dateOfBirth}
                  onChange={this.handleChange}
                />
              </div>
            </section>

            <section className="inputBox">
              <label>Location</label>
              <div>
                <input
                  autocomplete="off"
                  type="text"
                  name="location"
                  value={location}
                  onChange={this.handleChange}
                />
              </div>
            </section>
          </article>

          <article className="botBox">
            <h1>Personal details</h1>

            <section className="inputBox">
              <label>First Name</label>
              <div>
                <input
                  autocomplete="off"
                  type="text"
                  name="firstName"
                  value={firstName}
                  onChange={this.handleChange}
                />
              </div>
            </section>

            <section className="inputBox">
              <label>Last Name</label>
              <div>
                <input
                  autocomplete="off"
                  type="text"
                  name="lastName"
                  value={lastName}
                  onChange={this.handleChange}
                />
              </div>
            </section>

            <section className="inputBox">
              <label>Mobile Phone</label>
              <div>
                <input
                  autocomplete="off"
                  type="number"
                  name="mobilePhone"
                  value={mobilePhone}
                  onChange={this.handleChange}
                />
              </div>
            </section>

            <section className="inputBox">
              <label>Address</label>
              <div>
                <input
                  autocomplete="off"
                  type="text"
                  name="address"
                  value={address}
                  onChange={this.handleChange}
                />
              </div>
            </section>

            <section className="inputBox">
              <label>City</label>
              <div>
                <input
                  autocomplete="off"
                  type="text"
                  name="city"
                  value={city}
                  onChange={this.handleChange}
                />
              </div>
            </section>

            <div className="countryPostBox">
              <section className="inputBoxSmall">
                <label>Country/Region</label>
                <div>
                  <input
                    autocomplete="off"
                    type="text"
                    name="countryRegion"
                    value={countryRegion}
                    onChange={this.handleChange}
                  />
                </div>
              </section>
              <section className="inputBoxSmall">
                <label>Post Code</label>
                <div>
                  <input
                    autocomplete="off"
                    type="number"
                    name="postCode"
                    value={postCode}
                    onChange={this.handleChange}
                  />
                </div>
              </section>
            </div>
          </article>
          <button className="formbutton" type="submit">
            Update
          </button>

          <article className="emailBotBox">
            <h1>Email Address</h1>

            <section className="emailBox">
              <div>
                <img src="/images/check.png" />
              </div>

              <div>
                <h3>{email}</h3>
                <p>Email confirmed</p>
              </div>
            </section>
          </article>
        </form>
      </main>
    );
  }
}
export default EditProfile;
